<template>
  <div class="transition content-info">
    <div class="icon-items">
      <BasicIcon
        name="danger"
        active
      />
    </div>


    <BasicText>
      {{ MSG_INFO_FSE }}
    </BasicText>


  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents } from '@/features/interface/machine-etats/types';
import { BasicIcon, BasicText } from '@designSystem/components';
import { MSG_INFO_FSE } from '../../shared';

  const emits = defineEmits<CarteEvents<void>>()

  emits('outChanged', false)
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';

  .icon-items {
    background-color: white;
    color: @warning-500;
    align-self: center;
    margin-bottom: 10px;
    svg {
      fill: @warning-500;
      transform: scale(3);
    }
  }

  .content-info {
    width: 500px;
  }

  @media screen and (max-width: 720px) {
    .content-info {
      width: 100%;
    }
  }
</style>

